import styled from 'styled-components'
import { Box, Button, Link } from '@mui/material'
import Card from '../Card'
import { Slide } from "react-awesome-reveal"
import { useMedia } from 'react-use'
import SwiperCore, { Navigation } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #0C0720;
  margin-top: -5px;
  padding: 0 5%;
  padding-top:100px;
  @media(max-width:800px){
    padding-top:0px;
  }
`

const StyledLink = styled(Link)`
  text-decoration: none !important;
  color: #E354FA !important;
  &:hover{
    text-decoration: none;
  }
`

const Title = styled.div`
  font-size: 96px;
  line-height: 104px;
  font-weight: 700;
  color: #84FF70;
  letter-spacing: -1px;
  text-transform: uppercase;

  @media (max-width: 480px) {
    font-size: 64px;
  }
`

const SubTitle = styled.div`
  font-weight: 700;
  font-size: 40px;
  line-height: 64px;
  color: #7381FC;
  margin-top: 250px;
  @media(max-width:800px){
    margin-top:70px;
  }
`

const Vtext = styled.div<{ size: number, color: string }>`
  font-weight: 300;
  font-size: ${({ size }) => size}px;
  line-height: 22px;
  color: ${({ color }) => color};
  max-width: 638px;
  width: 95%;
  text-align: center;
  margin-top: 24px;
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 1150px;
  width: 90%;
  margin: 0 auto;
`
const Side = styled.div`
  display:flex;
  flex-direction:column;
  justify-content:space-between;
`
const StyledButton = styled(Button)`
  border: 1px solid #7381FC !important;
  border-radius: 8px !important;
  padding: 16px 24px !important;
  font-family: 'Poppins' !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 22px !important;
  color: #E354FA !important;
  text-transform: none !important;
`

const Image = styled.img`
  margin: 30px 10px;
`

const Flex = styled.div`
  display: flex;
  align-items: center;
`

const MapDatas = [
  {
    date: "Completed at Q2-2021",
    title: "Robust Protocol Launch",
    description: "Robust Protocol was launched as a platform for creating innovative blockchain DeFi projects."
  },
  {
    date: "Completed at Q2-2021",
    title: "Robust Token (RBT)",
    description: "Robust Protocol Token (RBT) is the flagship token of the Robust Protocol ecosystem. It features an extremely limited and deflating supply with other original concepts that makes it a rare gem in a DeFi landscape inundated with quadrillion supply meme tokens."
  },
  {
    date: "Completed at Q2-2021",
    title: "Robust Reward (RBW)",
    description: "RBW is used to reward users who assist in ensuring that the supply of RBT deflates. The token will be used for governance of the ecosystem."
  },
  {
    date: "Started at Q2-2021 (Ongoing)",
    title: "Marketing and Listings",
    description: "Engaging in various marketing campaigns including Reddit, Twitter, YouTube, TikTok and others."
  },
  {
    date: "Completed at Q3-2021",
    title: "RobustSwap Launch",
    description: "RobustSwap is the pilot Decentralized Exchange (DEX) of the Robust Protocol ecosystem. It includes yield farming, staking, liquidity mining, swapping and other exciting features."
  },
  {
    date: "Completed at Q3-2021",
    title: "RobustSwap Token (RBS)",
    description: "Robust Protocol was launched as a platform for creating innovative blockchain & DeFi projects."
  },
  {
    date: "Completed at Q2-2022",
    title: "RobustSwap Addons",
    description: "Automated Market Maker (AMM), Trade Mining."
  }
]

const UpcomingList = [
  ['Stablecoin', '(Robust Protocol Dollar)'],
  ['NFT Marketplace', ''],
  ['Blockchain Gaming', ''],
  ['Multichain Integration', ''],
  ['Lending and Borrowing', ''],
  ['Lottery', ''],
  ['Analytics Platform', ''],
  ['Robust Protocol App', '']
]

SwiperCore.use([Navigation])

const Roadmap = () => {
  const isMobile = useMedia('(max-width:800px)')
  const isLess600 = useMedia('(max-width:600px)')

  return (
    <Wrapper id="Roadmap" className='road'>
      <Title>Roadmap</Title>
      <Vtext size={18} color="#FCFCFC">
        We have proudly accomplished parts of our roadmap. Below are some of the projects we have completed thus far:
      </Vtext>
      <Box sx={{ backgroundImage: 'url(assets/svg/img-parallax-bg.svg)', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', width: '100%', mt: isMobile ? '50px' : '144px' }}>
        <div className="menu">
          <Container>
            <Side>
              {/* @ts-ignore */}
              <Slide triggerOnce direction='left'>
                <Card content={MapDatas[0]} />
                <Card content={MapDatas[1]} />
                <Card content={MapDatas[2]} />
              </Slide>
            </Side>
            <Side>
              {/* @ts-ignore */}
              <Slide triggerOnce direction='right'>
                <Card content={MapDatas[3]} />
                <Card content={MapDatas[4]} />
                <Card content={MapDatas[5]} />
                <Card content={MapDatas[6]} />
              </Slide>
            </Side>
          </Container>
        </div>
      </Box>
      <SubTitle>UPCOMING</SubTitle>
      <Vtext size={18} color="#FCFCFC">
        Our clear vision and the support from our community, we have planned the following item to enhance the ecosystem
      </Vtext>
      <StyledLink href="https://docs.robustprotocol.fi/roadmap" target="_blank" sx={{ mt: '32px', maxWidth: '370px', width: '95%' }}>
        <StyledButton className='next_slider' variant='outlined' sx={{ pointerEvents: 'none', width: '100%' }}>
          <Swiper
            direction='vertical'
            loop={true}
            slidesPerView={1}
            navigation={{
              nextEl: '.next_slider',
              prevEl: '.prev_slider'
            }}
            style={{ maxHeight: isLess600 ? '55px' : '25px', pointerEvents: 'none' }}>
            {UpcomingList.map((list, index) => {
              return (
                <SwiperSlide key={index} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: '4px' }}>
                  <span>{list[0]}</span>
                  <span>{list[1]}</span>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </StyledButton>
      </StyledLink>
      <Flex>
        <div className='prev_slider' style={{ cursor: "pointer" }}>
          <Image src="assets/svg/arrow-up-line.svg" />
        </div>
        <div className='next_slider' style={{ cursor: "pointer" }}>
          <Image src="assets/svg/arrow-down-line.svg" />
        </div>
      </Flex>
      <Vtext size={18} color="#7381FC">
        Please note that this roadmap is subject to change without prior notice and any estimated delivery dates are only guidelines and not guarantees.
      </Vtext>
    </Wrapper>
  )
}

export default Roadmap